export default {
      id: "menu-calling-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#menu-calling-usage",
      toString: function () {
        return this.url;
      }
    }